import { render } from "./panelFrame.vue?vue&type=template&id=6d099274"
import script from "./panelFrame.vue?vue&type=script&lang=js"
export * from "./panelFrame.vue?vue&type=script&lang=js"

import "./panelFrame.vue?vue&type=style&index=0&id=6d099274&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__